import { AZURE_BLOB_CONTAINER } from '../config/env/app';
import { IS_LOCAL } from '../config/env';

export const proxyBlobContainer = (link: string) => IS_LOCAL
    ? link.replace(AZURE_BLOB_CONTAINER, location.origin)
    : link
